"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipTriangle = exports.TooltipAction = exports.TooltipWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TooltipWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__TooltipWrapper",
  componentId: "sc-792ne4-0"
})(["background:white;border-radius:0.4rem;position:absolute;top:", ";right:", ";color:black;box-shadow:0 10px 20px rgba(0,0,0,0.19),0 6px 6px rgba(0,0,0,0.23);transition:all 0.3s cubic-bezier(0.25,0.8,0.25,1);width:12rem;padding:0rem 1rem;display:flex;flex-direction:column;align-items:flex-end;cursor:pointer;z-index:9999 !important;"], function (_ref) {
  var top = _ref.top;
  return top || '2rem';
}, function (_ref2) {
  var right = _ref2.right;
  return right || '3.5rem';
});

exports.TooltipWrapper = TooltipWrapper;

var TooltipAction = _styledComponents["default"].div.withConfig({
  displayName: "styles__TooltipAction",
  componentId: "sc-792ne4-1"
})(["font-size:1rem;font-weight:normal;padding:0.6rem 0;"]);

exports.TooltipAction = TooltipAction;

var TooltipTriangle = _styledComponents["default"].div.withConfig({
  displayName: "styles__TooltipTriangle",
  componentId: "sc-792ne4-2"
})(["width:0;height:0;border-left:0.8rem solid transparent;border-right:0.8rem solid transparent;border-bottom:0.8rem solid rgba(255,255,255,0.9);font-size:0;line-height:0;position:absolute;top:-0.2rem;right:0;"]);

exports.TooltipTriangle = TooltipTriangle;